{% block swag_paypal_pos_wizard_product_selection %}
    <div class="swag-paypal-pos-wizard-product-selection">

        {% block swag_paypal_pos_wizard_product_selection_info %}
            <p class="swag-paypal-pos-wizard-product-selection__info">
                {{ $t('swag-paypal-pos.wizard.productSelection.info') }}
            </p>
        {% endblock %}

        {% block swag_paypal_pos_wizard_product_selection_sales_channel_toggle %}
            <mt-switch
                    v-model="hasClone"
                    class="swag-paypal-pos-wizard-product-selection__clone-switch"
                    bordered
                    :label="$t('swag-paypal-pos.wizard.productSelection.labelToggle')"
                    @update:modelValue="updateClone" />
        {% endblock %}

        {% block swag_paypal_pos_wizard_product_selection_sales_channel_select %}
            <sw-entity-single-select
                    v-model:value="localCloneSalesChannelId"
                    class="swag-paypal-pos-wizard-product-selection__saleschannel-select"
                    entity="sales_channel"
                    :criteria="salesChannelCriteria"
                    :disabled="!hasClone"
                    :label="$t('swag-paypal-pos.wizard.productSelection.labelSelect')"
                    @update:value="forceUpdate" />
        {% endblock %}
    </div>
{% endblock %}
